( function( window, document, $ ) {
    'use strict';

    $( document ).ready( function() {
        // --------------------------------------------------
        // DECLARE VARS
        // --------------------------------------------------
        // Elems.
        var singleHeaderElem;

        // Data
        var scrollTimeout = null;
        var scrollDebounce = 100;

        // State
        var hasExecuted = false;

        // --------------------------------------------------
        // DEFINE FUNCTIONS
        // --------------------------------------------------
        function findElements() {
            singleHeaderElem = $( '.js--suggested' );
        }

        function handleSingleHeaderElem() {
            var scrollTop = $( window ).scrollTop();

            // Ensure that elem. ref. exists.
            if ( singleHeaderElem && singleHeaderElem.length ) {
                if ( scrollTop >= 500 && !singleHeaderElem.hasClass( 'is-active' ) ) {
                    singleHeaderElem.addClass( 'is-active' );
                } else if ( scrollTop < 500 && singleHeaderElem.hasClass( 'is-active' ) ) {
                    singleHeaderElem.removeClass( 'is-active' );
                }
            }
        }

        function init() {
            // Get/refresh elem. refs.
            findElements();

            // EVENTS
            // NOTE: Due to PJAX integration, extra step required to prevent event listeners/handlers from being registered multiple times.
            if ( !hasExecuted ) {
                $( window ).on( 'scroll', function() {
                    if ( !scrollTimeout ) {
                        scrollTimeout = setTimeout( function() {
                            scrollTimeout = null;
                            handleSingleHeaderElem();
                        }, scrollDebounce );
                    }
                } );
            }

            // Update flag.
            hasExecuted = true;
        }

        // --------------------------------------------------
        // INIT
        // --------------------------------------------------
        init();

        if ( typeof Barba !== 'undefined' && typeof Barba.Dispatcher === 'object' ) {
            Barba.Dispatcher.on( 'newPageReady', function() {
                init();
            } );
        }

    } );
} )( window, document, jQuery );
